import React, {
    createContext,
    useCallback,
    useContext,
    useState,
} from "react";

// Create the Schedules Context
export const RecordingsContext = createContext();

// Custom hook to use the Posts Context
export const useRecordings = () => useContext(RecordingsContext);

const fetchRecordings = async (streamId, setRecordings) => {
    try {
        const response = await fetch(
            `/wp-json/ccl_admin/v2/streams/${streamId}/recordings`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );

        if (!response.ok) {
            throw new Error("Failed to fetch Recording data");
        }

        const data = await response.json();
        setRecordings(data.reverse());
    } catch (err) {
        setRecordings([]);
    }
};

export const RecordingsProvider = ({ children }) => {
    const [recordings, setRecordings] = useState([]);

    const getRecordings = useCallback(async (streamId) => {
        if (recordings.length > 0) return recordings;
        await fetchRecordings(
            streamId,
            setRecordings
        );

    }, [recordings]);

    return (
        <RecordingsContext.Provider
            value={{
                recordings,
                getRecordings,
            }}
        >
            {children}
        </RecordingsContext.Provider>
    );
};
